import {css, useTheme} from "@emotion/react";

import {Accordion} from "@pg-design/accordion-module";
import {Container} from "@pg-design/grid-module";
import {calculateRemSize, color, flex, flexDirection, maxHeight, mb, onDesktop} from "@pg-design/helpers-css";
import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {capitalize} from "@pg-mono/nodash";
import {useUserDevice} from "@pg-mono/user-device";
import {PRICES_CITIES} from "@pg-rp/navigation";

import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {PricesViewType} from "../helpers/prices_view_type";
import {getCityLink} from "../utils/get_city_link";
import {getPricesTextFromType} from "../utils/get_from_prices_type";

interface IProps {
    type: PricesViewType;
    region?: IRegionReportPrice;
}

export const PricesLinks = (props: IProps) => {
    const {isMobile} = useUserDevice();
    const theme = useTheme();

    const linksHeaderText = `${capitalize(getPricesTextFromType(props.type))}`;

    const links = () => {
        return (
            <div css={linksHolder}>
                {PRICES_CITIES.map((city) => {
                    if (!props.region || city.slug != props.region.slug) {
                        return (
                            <Link key={city.slug} href={getCityLink(city.slug)} size={isMobile ? "small" : undefined} css={color(theme.colors.gray[700])}>
                                {linksHeaderText} {city.name}
                            </Link>
                        );
                    }
                })}
            </div>
        );
    };

    return (
        <Container css={mb(9)}>
            {isMobile ? (
                <Accordion>
                    <Accordion.Header>
                        <Text as="h2" variant="body_copy_2">
                            {`${linksHeaderText} w Polsce`}
                        </Text>
                    </Accordion.Header>
                    <Accordion.Content>{links()}</Accordion.Content>
                </Accordion>
            ) : (
                <>
                    <Text as="h2" variant="headline_6" css={mb(1)}>
                        {`${linksHeaderText} w Polsce`}
                    </Text>

                    {links()}
                </>
            )}
        </Container>
    );
};

const linksHolder = css`
    ${flex("flex-start", "center")};
    ${flexDirection("column")};
    gap: ${calculateRemSize(3)};

    ${onDesktop(css`
        ${maxHeight("220px")};
        align-content: flex-start;
        gap: ${calculateRemSize(1.5)};
        column-gap: ${calculateRemSize(8)};
        flex-wrap: wrap;
    `)};
`;
import {css, useTheme} from "@emotion/react";

import {Accordion} from "@pg-design/accordion-module";
import {Container} from "@pg-design/grid-module";
import {calculateRemSize, color, flex, flexDirection, maxHeight, mb, onDesktop} from "@pg-design/helpers-css";
import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {capitalize} from "@pg-mono/nodash";
import {useUserDevice} from "@pg-mono/user-device";
import {PRICES_CITIES} from "@pg-rp/navigation";

import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {PricesViewType} from "../helpers/prices_view_type";
import {getCityLink} from "../utils/get_city_link";
import {getPricesTextFromType} from "../utils/get_from_prices_type";

interface IProps {
    type: PricesViewType;
    region?: IRegionReportPrice;
}

export const PricesLinks = (props: IProps) => {
    const {isMobile} = useUserDevice();
    const theme = useTheme();

    const linksHeaderText = `${capitalize(getPricesTextFromType(props.type))}`;

    const links = () => {
        return (
            <div css={linksHolder}>
                {PRICES_CITIES.map((city) => {
                    if (!props.region || city.slug != props.region.slug) {
                        return (
                            <Link key={city.slug} href={getCityLink(city.slug)} size={isMobile ? "small" : undefined} css={color(theme.colors.gray[700])}>
                                {linksHeaderText} {city.name}
                            </Link>
                        );
                    }
                })}
            </div>
        );
    };

    return (
        <Container css={mb(9)}>
            {isMobile ? (
                <Accordion>
                    <Accordion.Header>
                        <Text as="h2" variant="body_copy_2">
                            {`${linksHeaderText} w Polsce`}
                        </Text>
                    </Accordion.Header>
                    <Accordion.Content>{links()}</Accordion.Content>
                </Accordion>
            ) : (
                <>
                    <Text as="h2" variant="headline_6" css={mb(1)}>
                        {`${linksHeaderText} w Polsce`}
                    </Text>

                    {links()}
                </>
            )}
        </Container>
    );
};

const linksHolder = css`
    ${flex("flex-start", "center")};
    ${flexDirection("column")};
    gap: ${calculateRemSize(3)};

    ${onDesktop(css`
        ${maxHeight("220px")};
        align-content: flex-start;
        gap: ${calculateRemSize(1.5)};
        column-gap: ${calculateRemSize(8)};
        flex-wrap: wrap;
    `)};
`;
